import React, { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles, Box } from '@material-ui/core';
import { AdminSettingsProvider } from 'src/contexts/AdminSettingsContext';
import NavBar from './NavBar';
import TopBar from './TopBar';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const Loader = () => {
  const [times, setTimes] = useState(1);
  useEffect(() => {
    setTimeout(() => {
      setTimes(t => (t === 3 ? 1 : t + 1));
    }, 500);
  }, [times]);
  return (
    <Box py={5} textAlign="center">
      Loading
      {'.'.repeat(times)}
    </Box>
  );
};

const DashboardLayout = () => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content} id="dashboard-scroller">
            <AdminSettingsProvider>
              <Suspense fallback={<Loader />}>
                <Outlet />
              </Suspense>
            </AdminSettingsProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
